var app = angular.module('leonardo');

var DynamicFormRestService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('dynamic-forms', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('dynamic-forms', false, function(dynamic_form) {
      dynamic_form.addRestangularMethod('moveTo', 'post', 'move');
      dynamic_form.addRestangularMethod('copyTo', 'post', 'copy');
      dynamic_form.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      dynamic_form.addRestangularMethod('cloneToAccount', 'post', 'clone-to-account');
      dynamic_form.addRestangularMethod('cloneToSystem', 'get', 'clone-to-system');
      return dynamic_form;
    });
  });

  service.SCORE_NOSCORE = 0;
  service.SCORE_AMOUNT = 1;
  service.SCORE_AVERAGE = 2;

  service.SCORE_OPTIONS = [
    {
      id: service.SCORE_NOSCORE,
      name: 'No Score'
    },
    {
      id: service.SCORE_AMOUNT,
      name: 'Amount'
    },
    {
      id: service.SCORE_AVERAGE,
      name: 'Average'
    }
  ];

  service.bulkObject = function(account) {
    return {
      account: account,
      fields: [],
      images_layout: 0
    };
  };

  service.optionsForExportContent = {};
  return service;
};

app.factory('DynamicFormRestService', ['BaseRestService', 'Restangular', DynamicFormRestService]);
